import { publicApi } from 'api';
import { createSlice } from '@reduxjs/toolkit';
import { Dispatch } from 'redux';
import { getItemFromLocalStorage, removeItemFromLocalStorage } from 'helpers/localstorage';
import {
  IAuthUserDetails,
  ILoginDetails,
  ILoginResponse,
  IResetPasswordRequest,
  IAuthOrganizations,
} from 'interfaces/auth-pages-interfaces';

interface IAuthStateType {
  user: ILoginResponse | null;
  userDetails: IAuthUserDetails | null;
  selectedOrganization: IAuthOrganizations | null;
  userRole: string | null;
}

const userIntialValue: ILoginResponse = getItemFromLocalStorage('user');
const selectedIntialOrganization: IAuthOrganizations = getItemFromLocalStorage('org');

const initialState: IAuthStateType = {
  user: userIntialValue || null,
  userDetails: userIntialValue?.user_details || null,
  selectedOrganization: selectedIntialOrganization || null,
  userRole: selectedIntialOrganization?.role_name || null,
};

const authSlice = createSlice({
  name: 'Auth',
  initialState: initialState,
  reducers: {
    setUserData: (state, { payload }: { payload: ILoginResponse | null }) => {
      state.user = payload;
      state.userDetails = payload?.user_details || null;
      state.selectedOrganization = payload?.login_details[0] || null;
      state.userRole = payload?.login_details[0].role_name || null;
    },
    setSelectedAuthOrganization: (state, { payload }: { payload: IAuthOrganizations | null }) => {
      state.selectedOrganization = payload || null;
    },
  },
});

export const login = (payload: { request: ILoginDetails }) => async (dispatch: Dispatch) => {
  try {
    const { request } = payload;
    const { data: responseData } = await publicApi.post('/admin/login', {
      ...request,
    });
    dispatch(setUserData(responseData?.data));
    return Promise.resolve(responseData?.data);
  } catch (error) {
    return Promise.reject(error);
  }
};
export const forgotPassword =
  (payload: { request: Pick<ILoginDetails, 'email'> }) => async (dispatch: Dispatch) => {
    try {
      const { request } = payload;
      const { data: responseData } = await publicApi.post('/forgot-password', request);
      return Promise.resolve(responseData?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  };
export const resetPassword =
  (payload: { request: IResetPasswordRequest }) => async (dispatch: Dispatch) => {
    try {
      const { request } = payload;
      const { data: responseData } = await publicApi.post('/reset-password', request);
      return Promise.resolve(responseData?.data);
    } catch (error) {
      return Promise.reject(error);
    }
  };
export const logout = () => async (dispatch: Dispatch) => {
  try {
    dispatch(setUserData(null));
    removeItemFromLocalStorage('org');
    removeItemFromLocalStorage('user');
    return Promise.resolve(true);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const { setUserData, setSelectedAuthOrganization } = authSlice.actions;
export default authSlice.reducer;
